import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets.app/images/celebrate.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "notification__play-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " You have successfully canceled your subscription during the free trial and you will not be charged. You can re-subscribe at any time—we'd love to have you back! ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " In the meantime, we'll keep working hard to make Shortform better. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " You've canceled your subscription and you will not be charged again in the future. You can re-subscribe at any time—we'd love to have you back! ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " In the meantime, we'll keep working hard to make Shortform better. ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "notification__play-icon"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "notification__play-icon"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "notification__play-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, " You now have full access to Shortform. We'll redirect you to books shortly... ", -1)

import { BillingView } from '@/models/billing'

import NotificationBox from '@/components/ui/NotificationBox.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingNotifications',
  props: {
    billing: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.billing.showPricesAfterDiscount)
      ? (_openBlock(), _createBlock(NotificationBox, {
          key: 0,
          hideCloseButton: ""
        }, {
          icon: _withCtx(() => [
            _hoisted_1
          ]),
          title: _withCtx(() => [
            _createTextVNode("Your discount has been applied!")
          ]),
          text: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(__props.billing.cancelDiscountAlertText), 1)
          ]),
          link: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.statusMessage)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 1 }, {
          title: _withCtx(() => [
            _createTextVNode(" Billing Status ")
          ]),
          text: _withCtx(() => [
            _createElementVNode("p", {
              innerHTML: __props.billing.statusMessage
            }, null, 8, _hoisted_3)
          ]),
          link: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.afterCancelTrialAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 2 }, {
          icon: _withCtx(() => [
            _hoisted_5
          ]),
          title: _withCtx(() => [
            _createTextVNode(" You Have Successfully Canceled ")
          ]),
          text: _withCtx(() => [
            _hoisted_6,
            _hoisted_7
          ]),
          link: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.afterCancelPaidAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 3 }, {
          icon: _withCtx(() => [
            _hoisted_9
          ]),
          title: _withCtx(() => [
            _createTextVNode(" You Have Successfully Canceled ")
          ]),
          text: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          link: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.subscribedAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 4 }, {
          icon: _withCtx(() => [
            (__props.billing.plan.id === 'plan_annual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : (_openBlock(), _createElementBlock("span", _hoisted_16))
          ]),
          title: _withCtx(() => [
            (__props.billing.plan.id === 'plan_annual')
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, " You've successfully changed to the annual plan! "))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, " You've successfully changed to the monthly plan. "))
          ]),
          text: _withCtx(() => [
            (__props.billing.plan.id === 'plan_annual')
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, " You now save " + _toDisplayString(__props.billing.switchToAnnualSavings.percent) + "% on your Shortform subscription. Wise choice! ", 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_20, " Change back to the annual plan anytime to save " + _toDisplayString(__props.billing.switchToAnnualSavings.percent) + "% off the subscription price. ", 1))
          ]),
          link: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'books' },
              class: "btns"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Open Books")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.resubscribedAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 5 }, {
          icon: _withCtx(() => [
            (__props.billing.plan.id === 'plan_annual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
              : (_openBlock(), _createElementBlock("span", _hoisted_24))
          ]),
          title: _withCtx(() => [
            (__props.billing.plan.id === 'plan_annual')
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, " You've successfully resubscribed to the annual plan! "))
              : (_openBlock(), _createElementBlock("span", _hoisted_26, " You've successfully resubscribed to the monthly plan! "))
          ]),
          text: _withCtx(() => [
            _hoisted_27
          ]),
          link: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'books' },
              class: "btns"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Open Books")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.downgradedAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 6 }, {
          icon: _withCtx(() => [
            _hoisted_28
          ]),
          title: _withCtx(() => [
            _createElementVNode("span", null, " You've successfully downgraded to the Monthly plan! Your Annual plan will continue until " + _toDisplayString(__props.billing.billingPeriodEnd) + " and then will switch to Monthly. ", 1)
          ]),
          text: _withCtx(() => [
            _hoisted_29
          ]),
          link: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'books' },
              class: "btns"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Open Books")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.upgradedAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 7 }, {
          icon: _withCtx(() => [
            _hoisted_30
          ]),
          title: _withCtx(() => [
            _createElementVNode("span", null, " You've successfully upgraded to the Annual plan! Your Monthly plan will continue until " + _toDisplayString(__props.billing.billingPeriodEnd) + " and then will switch to Annual. ", 1)
          ]),
          text: _withCtx(() => [
            _hoisted_31
          ]),
          link: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'books' },
              class: "btns"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Open Books")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.subscribedAlertAndRedirect)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 8 }, {
          icon: _withCtx(() => [
            _hoisted_32
          ]),
          title: _withCtx(() => [
            _createTextVNode(" Welcome to Shortform! ")
          ]),
          text: _withCtx(() => [
            _hoisted_33
          ]),
          link: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'books' },
              class: "btns btns--large"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Open Books")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})